export default __webpack_public_path__ + "static/media/collaborate-1.a377130f.gif";